import { Icon } from '../../../Icon'
import { tm } from '../../../tm'
import i18n from './i18n'
import type { Locales, Project } from '@captaincause/types'

interface DoneProjectBadgeProps {
  project: Project
  locale: Locales
  className?: string
}

export function DoneProject({
  project,
  locale,
  className = '',
}: DoneProjectBadgeProps) {
  if (!project.is_done) return null

  const t = i18n[locale]

  return (
    <div
      className={tm(
        'flex h-8 items-center rounded-full bg-light-green px-3 py-2 text-center shadow-sm',
        className,
      )}
    >
      <span className="flex items-center text-xs font-medium leading-[18px] text-dark-green">
        <Icon
          icon="check-round"
          fill="fill-green"
          className="mr-1"
          size="small"
        />
        {t.title}
      </span>
    </div>
  )
}
